import { render } from "./logDetail.vue?vue&type=template&id=dafa6a86&scoped=true"
import script from "./logDetail.vue?vue&type=script&lang=js"
export * from "./logDetail.vue?vue&type=script&lang=js"

import "./logDetail.vue?vue&type=style&index=0&id=dafa6a86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dafa6a86"]])

export default __exports__